import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../../BaseUrl";

export const exportAdminBomExcel = createAsyncThunk(
    "/admin/export-bom-excel",
    async (id) => {
        try {
            const myurl = `${V_URL}/believe/export-bom-excel/${id}`;
            const response = await axios({
                method: "get",
                url: myurl,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("VA_TOKEN"),
                },
            });
            const data = response.data;
            if (data.success === true) {
                return data;
            } else {
                throw new Error(data.message || "Failed to export BOM Excel");
            }
        } catch (error) {
            console.error("Error in exportAdminBomExcel:", error);
            toast.error(error.response?.data?.message || "Error exporting BOM Excel");
            throw error;
        }
    }
);

const exportAdminBomExcelSlice = createSlice({
    name: "exportAdminBomExcel",
    initialState: {
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(exportAdminBomExcel.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(exportAdminBomExcel.fulfilled, (state) => {
                state.loading = false;
                state.error = null;
            })
            .addCase(exportAdminBomExcel.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default exportAdminBomExcelSlice.reducer;
